<template>
  <ubi-page-container>
        <template v-slot:page-actions>
          <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" class="inline" v-loading="loadingExport">
              <span @click="eventAnalytics('export_header')">
                <downloadexcel
                    :fetch="exporter"
                    type="xls"
                    >
                    {{ $t("portals.report.exportResults") }}
                </downloadexcel>
              </span>
          </el-button>
        </template>
      <div v-loading="loading"
           :element-loading-text="$t('portals.list.chargementDonnees')">
        <ubi-panel :title="$t('contacts.generatedByAds')" size="sm">
          <el-row>
            <el-col :lg="24" :md="12">
              <el-row>
                <el-col :lg="12" class="mb-3">
                  <el-row>
                      {{ $t("contacts.listGeneratedContactsTotal") }}
                      <el-tooltip placement="top-start" :content="$t('contacts.listTooltipTotal')">
                          <em class="el-icon-question"></em>
                      </el-tooltip>
                      <span>&nbsp;</span><strong>{{nbContactsGeneresTotal}}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listGeneratedContactsAds") }} <strong>{{nbContactsGeneres}}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>
                      {{ $t("contacts.listActivePortals") }}
                      <strong>{{nbPortailsActifs}}</strong>
                  </el-row>
                  <el-col> <br></el-col>
                  <el-row>
                      {{ $t("contacts.listAdsSent") }}
                      <strong>{{nbAnnonces}}</strong>
                  </el-row>
                </el-col>
                <el-col :lg="12">
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
              </el-col>
              </el-row>

            </el-col>
          </el-row>
          <div class="Panel-footer">
            <el-collapse accordion>
                <el-collapse-item name="advanced" :title="$t('contacts.listGraphAdsSentDistribution')">
                 <el-row>
                   <el-col :span="2">
                      <br>
                    </el-col>
                    <el-col :lg="8">
                        <div class="text-muted" style="text-align: center;">
                            <pie-chart v-if="graphDataTypesBiens != null" :chart-data="graphDataTypesBiens" :options="null" ></pie-chart>
                            <div v-else style="text-align: center;">{{ $t("contacts.listTableNoData") }}</div>
                            <br>
                            {{ $t("contacts.listTablePropertyTypes") }}
                            <br>
                        </div>
                    </el-col>
                    <el-col :span="2">
                      <br>
                    </el-col>
                    <el-col :lg="8">
                        <div class="text-muted" style="text-align: center;">
                            <pie-chart v-if="graphDataTypesOffres != null" :chart-data="graphDataTypesOffres" :options="null" ></pie-chart>
                            <div v-else style="text-align: center;">{{ $t("contacts.listTableNoData") }}</div>
                            <br>
                            {{ $t("contacts.listTableOfferTypes") }}
                            <br>
                        </div>
                    </el-col>
                    <el-col :span="2">
                      <br>
                    </el-col>
                 </el-row>
                </el-collapse-item>
            </el-collapse>
          </div>
        </ubi-panel>

        <el-form @submit.prevent.native="fetchList">
          <ubi-panel style="background-color: #EBF3F2;">
            <ubi-search-container
            :filters="filters"
            @filter="doFilter"
            :defaultFilter="this.filter.presetPosts"
            v-on:resetfilter="doFilter('reset')"
            :more-opened="filter.advanced"
            @update:more-opened="advanced => setFilter({ advanced })">
              <el-form-item :label="$t('general.filters.titleReferenceCity')">
                <el-input type="text" @input="setSearch" :value="filter.search" :placeholder="$t('general.filters.adReferencePlaceholder')" />
              </el-form-item>
              <el-form-item :label="$t('general.filters.date')">
                  <el-date-picker
                          type="daterange"
                          :value="filter.beforeContacts || filter.afterContacts? [filter.beforeContacts || undefined, filter.afterContacts || undefined] : null"
                          :start-placeholder="$t('general.filters.dateCreationStart')"
                          :end-placeholder="$t('general.filters.dateCreationEnd')"
                          @input="dates => addFilter({ beforeContacts: dates? dates[0] : null, afterContacts: dates ? dates[1] : null})"
                          format="dd/MM/yyyy"
                          :picker-options="pickerOptions"
                  ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('general.filters.negociateur')" v-if="filtreNegociateur()">
                <el-select
                    v-model="filter.negociateur"
                    @input="negociateur => addFilter({ negociateur })"
                    :placeholder="$t('general.filters.negociateurPlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      v-for="negociateur in negociateurs"
                      :key="negociateur.id"
                      :label="negociateur.nom + ' ' + negociateur.prenom"
                      :value="negociateur.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </ubi-search-container>
          </ubi-panel>
        </el-form>
        <ubi-panel>
            <ubi-list-header slot="header"
            :limits="limits"
            :page.sync="pagePosts"
            :limit.sync="limit"
            :total="nbResults"
            :sort.sync="sort"
            :sortProperties="sortProperties"></ubi-list-header>

            <el-button v-if="nbContactsGeneresTotal > 0 && !user.roles.includes('ROLE_SUB_USER')" type="mini" slot="actions" v-loading="loadingExport" @click="exporter">
                  {{ $t("contacts.exportResults") }}
            </el-button>
            <ubi-list-footer slot="footer" :limits="limits" :page.sync="pagePosts" :limit.sync="limit" :total="nbResults"></ubi-list-footer>
            <el-table ref="table" :data="annonces">
            <el-table-column width="40">
                <template v-slot="{ row: result }">
                    <div v-if="result.etat === 'A'"></div>
                    <div v-else style="color: #d35b68">
                        <el-tooltip placement="top-start" :content="$t('contacts.listColumnTooltipAdNoSent')">
                            <em class="el-icon-question"></em>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="" width="160">
              <template v-slot="{ row: result }">
                <img width="80" v-if="result.photoPrincipale != null"
                  alt=""
                  :src="result.photoPrincipale.url_miniature"
                  :srcset="result.photoPrincipale.url_miniature"
                />
                  <div v-else style="text-align: center;"><ubi-icon class="no-photo" name="camera" size='60' /></div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnAd')"  width="220">
              <template v-slot="{ row: result }">
                  {{result.titre}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnReference')"  width="160">
              <template v-slot="{ row: result }">
                <router-link v-if="!isSubUser" :to="{ name: 'post-view', params: { post: result.id } }">
                  <strong>{{result.reference}}</strong>
                </router-link>
                <span v-else>
                  {{result.reference}}
                </span>
                <br>
                <el-tags-post :post="result" :size="tagPostSize"></el-tags-post>
              </template>
            </el-table-column>
            <el-table-column v-if="isPromoteur" :label="$t('contacts.typeObjetPromoteur')" width="120">
              <template v-slot="{ row: result }">
                <span v-if="result.annonceParente">{{ $t('contacts.listLot') }}</span>
                <span v-else>{{ $t('contacts.listProgramme') }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnActivePortals')" width="100">
                    <template v-slot="{ row: result }">{{result.nbPortailsActifs}}</template>
            </el-table-column>
            <el-table-column :label="$t('contacts.listColumnContacts')" width="120">
              <template v-slot="{ row: result }">
                  <router-link v-if="!isSubUser" :to="{ name: 'contacts-posts-detail', params: { post: result.reference } }">
                      {{result.nbContactsMailtracking}}
                  </router-link>
                  <span v-else>
                      {{result.nbContactsMailtracking}}
                  </span>
              </template>
            </el-table-column>
            </el-table>

        </ubi-panel>
      </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";
.el-loading-spinner{
    top:10%!important;
}
</style>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  getAnnoncesContacts,
  getContactsStatsEnTete,
  getAnnoncesSansContacts
} from '@/services/contacts'
import PieChart from '@/services/piechart'
import { Collapse, CollapseItem, Divider } from 'element-ui'
import TagsPosts from '../posts/components/TagsPosts'
import downloadexcel from 'vue-json-excel'
import { exportXlsPosts } from '@/services/posts'
import UbiPanel from '@/components/Panel.vue'
import UbiSearchContainer from '@/components/SearchContainer.vue'
import UbiListHeader from '@/components/lists/ListHeader.vue'
import UbiListFooter from '@/components/lists/ListFooter.vue'
import UbiIcon from '@/components/Icon.vue'
import { getNegociateurs } from '@/services/negociateurs'

export default {
  name: 'ContactsListPortals',
  inject: ['browserContext'],
  components: {
    UbiIcon,
    UbiListFooter,
    UbiListHeader,
    UbiSearchContainer,
    UbiPanel,
    PieChart,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    ElTagsPost: TagsPosts,
    downloadexcel
  },
  data () {
    return {
      loading: false,
      loadingExport: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      enTete: null,
      nbResults: 0,
      graphDataTypesBiens: null,
      tagPostSize: 'mini',
      graphDataTypesOffres: null,
      sortProperties: {
        reference: this.$t('general.sort.reference'),
        titre: this.$t('general.sort.title')
      },
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      nbPortailsActifs: 0,
      annonces: null,
      graphData: {},
      annoncesStats: {},
      refsFilter: null,
      negociateurs: [],
      filters: [
        { value: 'allAds', label: this.$t('general.filters.allAds') },
        { value: 'withContacts', label: this.$t('general.filters.adsWithContacts') },
        { value: 'active', label: this.$t('general.filters.onlyActiveAds') }
      ]
    }
  },
  computed: {
    ...mapState('contactsListPosts', ['filter', 'results']),
    ...mapGetters(['isSubUser', 'getPickerOptionsShortcuts']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    pagePosts: {
      get () {
        return this.filter.pagePosts
      },
      set (value) {
        this.setOffsetPosts((value - 1) * this.limit)
        this.setPagePosts(value)
        this.fetchList()
        return this.setPagePosts(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffsetPosts(0)
        this.setPagePosts(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffsetPosts(0)
        this.setPagePosts(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  },
  beforeMount () {
    this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    if (!this.user.roles.includes('ROLE_SUB_USER')) {
      this.filters.push({ value: 'withoutContacts', label: this.$t('general.filters.adsWithoutContacts') })
    }
    if (this.filtreNegociateur()) {
      this.callNegociateurs()
    }
  },
  mounted () {
    // this.setPagePosts(1);
    // this.setSort("R");
    // this.setLimit(10);
    // this.fetchList();//this is done inside searchfilter
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('contact_manager_annonces', 'clic', category, this.sitimmoUser.id)
    },
    formatExport (list) {
      const finalList = []
      list.forEach(element => this.findNbContacts(element))
      list.forEach(function (element) {
        const tabPortail = {}
        tabPortail.id = element.id
        tabPortail.reference = element.reference
        tabPortail.titre = element.titre
        tabPortail.annonceParente = element.annonceParente
        tabPortail.nbContactsMailtracking = element.nbContactsMailtracking
        tabPortail.dateDisponibilite = element.dateDisponibilite
        finalList.push(tabPortail)
      })
      return finalList
    },
    async exporter (event) {
      this.eventAnalytics(event)
      this.loadingExport = true
      const res = await exportXlsPosts(this.filter, null, true, 'ANNONCE_' + this.sitimmoUser.univers + '_MAILTRACKING')
      this.loadingExport = false
      this.$message(res)
    },
    async getEnTete () {
      this.enTete = await (getContactsStatsEnTete(this.filter))
      if (this.enTete.type == 'error') {
        this.loading = false
        return false
      }
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('contactsListPosts', [
      'setPage',
      'setPagePosts',
      'setOffsetPosts',
      'setLimit',
      'setSort',
      'setSearch',
      'setCategory',
      'setGratuit',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'resetFilter',
      'setBeforeContacts',
      'setAfterContacts'
    ]),
    handleClose (done) {
      this.$confirm(this.$t('general.exitConfirmation'))
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    doFilter (type) {
      delete this.filter.withoutContact
      switch (type) {
        case 'allAds':
          this.filter.refs = null
          this.filter.activeOnly = null
          this.filter.sort = 'reference'
          this.setFilter(this.filter)
          break
        case 'withContacts':
          this.filter.refs = this.refsFilter
          this.filter.activeOnly = null
          this.filter.sort = 'reference'
          this.setFilter(this.filter)
          break
        case 'active':
          this.filter.refs = null
          this.filter.activeOnly = true
          this.filter.sort = 'reference'
          this.setFilter(this.filter)
          break
        case 'reset':
          this.filter.search = ''
          this.filter.beforeContacts = moment().subtract(7, 'days')
          this.filter.afterContacts = moment()
          this.filter.activeOnly = null
          type = 'withContacts'
          break
        case 'withoutContacts':
          this.filter.refs = null
          this.filter.withoutContact = true
          this.setFilter(this.filter)
          break
      }
      this.filter.presetPosts = type
      this.fetchList()
    },
    async setAnnonceParente (idAnnonceParente) {
      this.setFilter({ annonceParente: idAnnonceParente })
      this.fetchList()
    },
    formatRefList (refs) {
      let strRefs = ''
      if (refs.length < 1) {
        strRefs = '0'
      } else {
        let i = 0
        for (const [key, value] of Object.entries(refs)) {
          if (i > 0) {
            strRefs = strRefs + ','
          }
          strRefs = strRefs + key
          i++
        }
      }
      return strRefs
    },
    findNbContacts (annonce) {
      for (const [key, value] of Object.entries(this.annoncesStats)) {
        if (key === annonce.reference) {
          annonce.nbContactsMailtracking = value
        }
      }
      if (annonce.nbContactsMailtracking === null) {
        annonce.nbContactsMailtracking = 0
      }

      return annonce
      // annonce.nbContactsMailtracking = Math.random()
    },
    async fetchList () {
      this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      // No need to interrupt promises when the router changes...
      this.loading = true
      await (this.getEnTete(this.filter))
      this.nbContactsGeneres = this.enTete.infos.nbContactsGeneres
      this.nbContactsGeneresTotal = this.enTete.infos.nbContactsGeneresTotal
      this.nbAnnonces = this.enTete.infos.nbAnnonces
      this.nbProspects = this.enTete.infos.nbProspects
      this.nbPortailsActifs = this.enTete.infos.nbPortailsActifs
      this.annoncesStats = this.enTete.infos.infosAnnonces
      this.refsFilter = this.formatRefList(this.annoncesStats)

      let annoncesContacts
      if (this.filter.presetPosts === 'withContacts') {
        this.filter.refs = this.refsFilter
        this.filter.activeOnly = null
        this.filter.sort = 'reference'
        annoncesContacts = await getAnnoncesContacts(this.filter)
      } else if (this.filter.presetPosts === 'withoutContacts') {
        this.filter.activeOnly = null
        this.filter.sort = 'reference'
        annoncesContacts = await getAnnoncesSansContacts(this.filter)
      } else {
        annoncesContacts = await getAnnoncesContacts(this.filter)
      }
      if (annoncesContacts.type === 'error') {
        this.loading = false
        return false
      }
      this.setResults(annoncesContacts)
      if (this.results.infos) {
        this.nbResults = this.results.infos.total_items
        this.annonces = this.results.infos._embedded.annonce
      }

      this.annonces.forEach(element => this.findNbContacts(element))

      // trie par contacts Descendants
      if (this.filter.sort === '-CTM') {
        this.annonces = this.annonces.sort((a, b) => b.nbContactsMailtracking - a.nbContactsMailtracking)
      }

      const labelsTypesBiens = Object.keys(this.enTete.infos.tabTypesObject)
      const valuesTypesBiens = Object.values(this.enTete.infos.tabTypesObject)
      this.graphDataTypesBiens = {
        labels: labelsTypesBiens,
        datasets: [{
          label: '# of Votes',
          data: valuesTypesBiens,
          borderWidth: 0,
          backgroundColor: ['rgba(255, 99, 132, 0.55)',
            'rgba(54, 162, 235, 0.55)',
            'rgba(255, 206, 86, 0.55)',
            'rgba(75, 192, 192, 0.55)',
            'rgba(153, 102, 255, 0.55)',
            'rgba(255, 159, 64, 0.55)']
        }]

      }
      if (valuesTypesBiens.length == 0) {
        this.graphDataTypesBiens = null
      }
      const labelsTypesOffres = Object.keys(this.enTete.infos.tabTypesOffre)
      const valuesTypesOffres = Object.values(this.enTete.infos.tabTypesOffre)
      this.graphDataTypesOffres = {
        labels: labelsTypesOffres,
        datasets: [{
          label: '# of Votes',
          data: valuesTypesOffres,
          borderWidth: 0,
          backgroundColor: [
            'rgba(255, 206, 86, 0.55)',
            'rgba(75, 192, 192, 0.55)',
            'rgba(153, 102, 255, 0.55)',
            'rgba(255, 159, 64, 0.55)']
        }]

      }
      if (valuesTypesOffres.length == 0) {
        this.graphDataTypesOffres = null
      }
      this.loading = false
    },
    async callNegociateurs () {
      this.filter.negociateur = null
      this.filter.reseau = 'EXP FRANCE'
      this.negociateurs = await getNegociateurs(this.filter)
    },
    filtreNegociateur () {
      return ((this.sitimmoUser.id == 342878) || this.sitimmoUser.betaTesteur)
    }
  }

}
</script>
